export var setHeaders = function (customCacheTTL, isBrowser, customRouting, isStagingRequest, bypassSsrInternalCache) {
    if (isStagingRequest === void 0) { isStagingRequest = false; }
    if (bypassSsrInternalCache === void 0) { bypassSsrInternalCache = false; }
    var headers = {};
    if (customCacheTTL && !isBrowser) {
        headers['x-wix-site-assets-custom-cache'] = customCacheTTL;
    }
    if (customRouting && !isBrowser) {
        var upstream = isStagingRequest ? 'site-assets-staging' : 'site-assets';
        headers["x-wix-route-".concat(upstream)] = customRouting;
    }
    if (bypassSsrInternalCache) {
        headers['x-wix-bypass-ssr-internal-cache'] = '1';
    }
    return headers;
};
